/* global customerAddress, uniservApiKey, uniservApiUrl */
let ADDRESSVALIDATION = {};

import { fetchRequest } from '../utils';

ADDRESSVALIDATION.validate = async function (addressData) {
  addressData.par_reduce_hits = 1;
  addressData.par_sel_list_max = 3;
  let esc = encodeURIComponent;
  let query = Object.keys(addressData)
    .map((k) => `${esc(k)}=${esc(addressData[k])}`)
    .join('&');
  const apiUrlWithQuery = uniservApiUrl + '?' + query;

  return fetchRequest(
    apiUrlWithQuery,
    null,
    {
      'X-Auth-Token': uniservApiKey,
      'Content-Type': 'application/json',
    },
    'get'
  );
};

ADDRESSVALIDATION.getUniservAddressDataObj = () => {
  return {
    in_zip: customerAddress.addressPostalCode,
    in_str_hno: customerAddress.addressStreet,
    in_city: customerAddress.addressCity,
    country: customerAddress.countryCode,
  };
};

ADDRESSVALIDATION.getEnteredAddress = () => {
  return {
    postalCode: customerAddress.addressPostalCode,
    street: customerAddress.addressStreet,
    city: customerAddress.addressCity,
    company: customerAddress.addressCompany,
    phoneNumber: customerAddress.addressPhoneNumber,
    countryCode: customerAddress.countryCode,
    country: customerAddress.countryShortName,
    countryName: customerAddress.addressCountryName,
    firstName: customerAddress.addressFirstName,
    lastName: customerAddress.addressLastName,
  };
};

ADDRESSVALIDATION.getUserAddressDataObj = () => {
  return {
    firstName: customerAddress.addressFirstName,
    lastName: customerAddress.addressLastName,
    company: customerAddress.addressCompany,
    street: customerAddress.addressStreet,
    city: customerAddress.addressCity,
    postalCode: customerAddress.addressPostalCode,
    country: {
      name: customerAddress.addressCountryName,
      iso3166Name: customerAddress.countryCode,
      shortName: customerAddress.countryShortName,
    },
  };
};

ADDRESSVALIDATION.createSuggestionsHTML = (userAddress, addresses) => {
  let addressSuggestion = '';
  let suggestedText =
    document.getElementsByClassName('js-suggestedText')[0].innerText;
  addresses.forEach(function (address, index) {
    let addressHTML = ADDRESSVALIDATION.matchAddress(address, userAddress);
    addressSuggestion += `<div class="accordion__panel ${
      index === 0 ? 'active' : ''
    }">
            <input id="suggestedAddress-${index}" type="radio" name="addressSuggestion" ${
              index === 0 ? 'checked' : ''
            } value="${index}" data-zta="suggestedAddressInput-${index}" tabindex="-1"/>
            <label class="accordion__label" for="suggestedAddress-${index}" data-zta="suggestedAddressLabel-${index}" tabindex="0">
                <svg class="radio-unchecked checkout__icon" aria-hidden="true"><use xlink:href="#circle"></use></svg>
                <svg class="radio-checked checkout__icon" aria-hidden="true"><use xlink:href="#circle-filled"></use></svg>
                <svg class="radio-disabled checkout__icon" aria-hidden="true"><use xlink:href="#radio-disabled"></use></svg>
                <div class="accordion__label__address">
                    <span class="item__name v3-p1--bold">${suggestedText}</span>
                    <span class="item__name v3-p1">
                        <span data-zta="suggestedAddressUserData-${index}">${buildUserDataForAddressSuggestion(
                          userAddress
                        )}</span><br>
                        <span data-zta="suggestedAddressText-${index}">${addressHTML}</span>
                    </span>
                </div>
            </label></div>`;
  });

  return addressSuggestion;
};

ADDRESSVALIDATION.createUserAddress = (userAddress) => {
  return `<span data-zta="enteredAddressUserData">${buildUserDataForAddressSuggestion(
    userAddress
  )}</span><br>
     <span data-zta="enteredAddressText">${userAddress.street}, ${
       userAddress.postalCode
     }, ${userAddress.city}, ${userAddress.country.name}</span>`;
};

let matchAddress = (suggestion, userAddress) => {
  let userAddressParts = userAddress.street.split(' ');
  let suggestionAddressParts = suggestion.out_str_hno.split(' ');
  let output = '';

  if (userAddressParts.length === suggestionAddressParts.length) {
    let matched = userAddressParts.map((part, index) => {
      if (part.toLowerCase() !== suggestionAddressParts[index].toLowerCase())
        return (
          '<span class="match bold">' +
          suggestionAddressParts[index] +
          '</span>'
        );
      else return suggestionAddressParts[index];
    });

    output = matched.join(' ');
  } else if (userAddressParts.length >= suggestionAddressParts.length) {
    let matched = suggestionAddressParts.map((part, index) => {
      if (part.toLowerCase() !== userAddressParts[index].toLowerCase())
        return '<span class="match bold">' + part + '</span>';
      else return part;
    });
    output = matched.join(' ');
  } else {
    let matched = userAddressParts.map((part, index) => {
      if (part.toLowerCase() !== suggestionAddressParts[index].toLowerCase())
        return (
          '<span class="match bold">' +
          suggestionAddressParts[index] +
          '</span>'
        );
      else return suggestionAddressParts[index];
    });

    let difference = suggestionAddressParts.splice(
      userAddressParts.length - suggestionAddressParts.length
    );

    difference = difference.map((part) => {
      return '<span class="match bold">' + part + '</span>';
    });

    output = matched.concat(difference).join(' ');
  }

  if (suggestion.out_zip !== userAddress.postalCode)
    output += ', <span class="match bold">' + suggestion.out_zip + '</span>';
  else output += ', ' + suggestion.out_zip;

  if (suggestion.out_city.toLowerCase() !== userAddress.city.toLowerCase())
    output += '<span class="match bold"> ' + suggestion.out_city + '</span>';
  else output += ' ' + suggestion.out_city;

  output += ', ' + userAddress.country.name;

  return output;
};

let buildUserDataForAddressSuggestion = (userAddress) => {
  return (
    userAddress.firstName +
    ' ' +
    userAddress.lastName +
    (userAddress.company ? ', ' + userAddress.company : '')
  );
};

let createUniservObject = (uniservInfo) => {
  return {
    mvalCity: uniservInfo.out_mval_city,
    mvalStr: uniservInfo.out_mval_str,
    outCity: uniservInfo.out_city,
    outCountry: uniservInfo.out_country,
    outCountryFull: uniservInfo.out_country_full,
    outHno: uniservInfo.out_hno,
    outResChange: uniservInfo.out_res_change,
    outResCity: uniservInfo.out_res_city,
    outResDeliverability: uniservInfo.out_res_deliverability,
    outResHno: uniservInfo.out_res_hno,
    outResPostCl: uniservInfo.out_res_post_cl,
    outResStr: uniservInfo.out_res_str,
    outResZip: uniservInfo.out_res_zip,
    outStr: uniservInfo.out_str,
    outStrHno: uniservInfo.out_str_hno,
    outZip: uniservInfo.out_zip,
  };
};

ADDRESSVALIDATION.matchAddress = matchAddress;

export default ADDRESSVALIDATION;
export { matchAddress, buildUserDataForAddressSuggestion };
export { createUniservObject as createUniservObj };
